<template>
  <div>
    <b-card body-class="requested-times p-0">
      <b-table
        :fields="columns"
        :items="tableRows"
        show-empty
        responsive
      >
        <template #head()="data">
          <span class="text-capitalize">{{ data.label }}</span>
        </template>
        <template #cell(startedAt)="data">
          {{ timeWithTimeZone(data.item.startedAt, timeZone, COMMON.DATE_TIME_FORMAT) }}
        </template>
        <template #cell(endedAt)="data">
          {{ timeWithTimeZone(data.item.endedAt, timeZone, COMMON.DATE_TIME_FORMAT) }}
        </template>
        <template #cell(duration)="data">
          <b-badge variant="primary" class="w-75">
            {{ CONVERT_HM(data.item.duration) }}
          </b-badge>
        </template>
        <template #cell(remarks)="data">
          <span
            v-if="data.item.remarks"
            v-b-tooltip.hover.left="data.item.remarks"
          >
            {{ data.item.remarks }}
          </span>
        </template>
        <template #cell(action)="data">
          <b-button
            variant="primary badge-glow"
            class="action-btn mr-2"
            @click="manualTimeToAccept = data.item"
          >
            <feather-icon icon="CheckIcon" />
          </b-button>
          <b-button
            variant="danger badge-glow"
            class="action-btn"
            @click="manualTimeToReject = data.item"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </template>
        <template #empty>
          <p class="w-100 text-center my-2">
            {{ $t('reports.no-requested-time') }}
          </p>
        </template>
      </b-table>
    </b-card>
    <confirm-modal
      :delete-params="{
        title: $t('Confirm'),
        body: $t('reports.accept-confirmation')
      }"
      variant="success"
      :visible="!!manualTimeToAccept"
      :processing="isProcessing"
      @close="manualTimeToAccept = null"
      @onConfirm="acceptManualTime"
    />
    <confirm-modal
      :delete-params="{
        title: $t('Confirm'),
        body: $t('reports.reject-confirmation')
      }"
      :processing="isProcessing"
      variant="danger"
      :visible="!!manualTimeToReject"
      @close="manualTimeToReject = null"
      @onConfirm="rejectManualTime"
    />
  </div>
</template>
<script>
import { BTable, BCard, BButton, BBadge, VBTooltip } from 'bootstrap-vue'
import ConfirmModal from '@/views/common/components/ConfirmModal.vue'
import useApollo from '@/plugins/graphql/useApollo'

export default {
  components: {
    BTable,
    BCard,
    BButton,
    BBadge,
    ConfirmModal,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    requestedManualTime: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns: [
        { key: 'startedAt', label: this.$t('Start Time') },
        { key: 'endedAt', label: this.$t('End Time') },
        { key: 'duration', label: this.$t('Duration') },
        { key: 'remarks', label: this.$t('Remarks'), tdClass: 'text-truncate--3', thStyle: 'border-bottom:0; width:20%' },
        { key: 'action', label: this.$t('Action') },
      ],
      manualTimeToAccept: null,
      manualTimeToReject: null,
      isProcessing: false,
    }
  },
  computed: {
    timeZone() {
      return this.$store.getters['project/FILTERED_TIMEZONE_OR_DEFAULT']?.value
    },
    tableRows() {
      const tableData = this.requestedManualTime?.data || []
      return tableData.map(table => ({
        ...table,
        duration: this.GET_TIME_DIFFERENCE(table.startedAt, table.endedAt),
      }))
    },
  },
  methods: {
    updateTime(decline, record) {
      return useApollo.activities.updatePendingManualTime({
        projectUid: this.$store.state.project.selectedProject,
        userUid: record.user.uuid,
        record: Number(record.id),
        decline,
      })
    },
    acceptManualTime() {
      this.isProcessing = true
      this.updateTime(false, this.manualTimeToAccept).then(response => {
        this.$emit('refetch')
        this.manualTimeToAccept = null
        this.showSuccess(response.data?.approveManualTimeRecord?.message)
      }).catch(error => {
        this.showErrorMessage(error)
      }).finally(() => { this.isProcessing = false })
    },
    rejectManualTime() {
      this.isProcessing = true
      this.updateTime(true, this.manualTimeToReject).then(response => {
        this.$emit('refetch')
        this.manualTimeToReject = null
        this.showSuccess(response.data?.approveManualTimeRecord?.message)
      }).catch(error => {
        this.showErrorMessage(error)
      }).finally(() => { this.isProcessing = false })
    },
  },
}
</script>

<style lang="scss">
.requested-times {
  .action-btn {
    padding: 8px;
  }
  .text-truncate--3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    padding: 4px 28px;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }
}
</style>